import { formatUSDT } from '../../../helpers/helpers';

interface ColumnsProps {
  onEdit: (row: any) => void;
}

export const getColumns = ({ onEdit }: ColumnsProps) => [
  {
    id: 1,
    Header: 'User ID',
    accessor: 'userId',
    Cell: (cell: any) => {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => onEdit(cell.row.original)}>
          {cell.value}
        </div>
      );
    }
  },

  {
    id: 3,
    Header: 'User',
    accessor: 'user',
    Cell: (cell: any) => {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => onEdit(cell.row.original)}>
          {cell.row.original.name} {cell.row.original.surname}
        </div>
      );
    }
  },
  {
    id: 4,
    Header: 'Email',
    accessor: 'email',
    Cell: (cell: any) => {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => onEdit(cell.row.original)}>
          {cell.value}
        </div>
      );
    }
  },
  {
    id: 5,
    Header: 'Ranking Sum Of POUV',
    accessor: 'rankingSumOfPoAndUv',
    Cell: (cell: any) => {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => onEdit(cell.row.original)}>
          {formatUSDT.format(cell?.value)}
        </div>
      );
    }
  },

  {
    id: 6,
    Header: 'Ranking 20%',
    accessor: 'ranking20Percent',
    Cell: (cell: any) => {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => onEdit(cell.row.original)}>
          {formatUSDT.format(cell?.value)}
        </div>
      );
    }
  },

  {
    id: 8,
    Header: 'Ranking 40%40%20%',
    accessor: 'ranking404020',
    Cell: (cell: any) => {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => onEdit(cell.row.original)}>
          {formatUSDT.format(cell?.value)}
        </div>
      );
    }
  },

  {
    id: 9,
    Header: 'PO Active',
    accessor: 'rankingPoActive',
    Cell: (cell: any) => {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => onEdit(cell.row.original)}>
          {formatUSDT.format(cell?.value)}
        </div>
      );
    }
  },
  {
    id: 10,
    Header: 'Left Leg',
    accessor: 'rankingLeftLegTotalVolume',
    Cell: (cell: any) => {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => onEdit(cell.row.original)}>
          {formatUSDT.format(cell?.value)}
        </div>
      );
    }
  },

  {
    id: 11,
    Header: 'Right Leg',
    accessor: 'rankingRightLegTotalVolume',
    Cell: (cell: any) => {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => onEdit(cell.row.original)}>
          {formatUSDT.format(cell?.value)}
        </div>
      );
    }
  },

  {
    id: 12,
    Header: 'Qualified partner rank',
    accessor: 'hasPartnerWithPaidPackageInBothLegs',
    Cell: (cell: any) => {
      if (cell.value) {
        return 'TRUE';
      } else {
        return 'FALSE';
      }
    }
  }
];
